exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer---1uBHj{background:#94b4c9;position:fixed;left:50%;bottom:0;min-height:2rem;min-width:25.5rem;padding:5px 2.25rem;border-radius:10px 10px 0 0;transform:translateX(-50%);transition:all .3s ease-out;font-size:.75rem;display:flex;justify-content:center;align-items:center}.collapsedContainer---2sCZx{left:85%;margin:0;width:auto;transition:all .3s ease-out;padding:3px 30px;min-width:8.5rem;height:2rem}.collapsedContainer---2sCZx *[data-name^=expanded]{display:none !important}.expandedContainer---1tcHW *[data-name^=collapsed]{display:none !important}button{height:30px;width:30px}.icon---2OYJF{position:absolute;top:8px;left:10px;cursor:pointer}.icon---2OYJF svg{width:16px;height:16px}.iconCollapsed---2hZvu{right:10px;left:auto}", ""]);

// exports
exports.locals = {
	"footer": "footer---1uBHj",
	"collapsedContainer": "collapsedContainer---2sCZx",
	"expandedContainer": "expandedContainer---1tcHW",
	"icon": "icon---2OYJF",
	"iconCollapsed": "iconCollapsed---2hZvu"
};